import { useAddress } from "@thirdweb-dev/react";
import { PublicationReactionType } from '@lens-protocol/client';
import { lensClient } from "../../client/LensClient";
import { ethers } from "ethers";
import { toast } from 'react-toastify';
import { useState,useEffect } from "react";
import "./interactionStyles.css";

export function AddReaction({id}){

  const address = useAddress();
  const provider = new ethers.providers.Web3Provider(window.ethereum);
  const signer = provider.getSigner();
  const [userID,setUserID] = useState();
  
    useEffect(()=>{
      async function fetchProfileId(){
        const profiles = await lensClient.profile.fetchAll({
          where: {
            ownedBy: [address],
          },
        })
        if(profiles.items.length!=0){
          setUserID(profiles?.items[0].id);
        }
      }
      fetchProfileId();
    },[])
    // v1 method to like 

    // const [likePost, { data, loading, error }] = useMutation(
    //     ADD_REACTION,
    //     {
    //       onCompleted: () => {
    //         toast.info("You Liked This Post.",{
    //           position:toast.POSITION.TOP_CENTER
    //          })
    //       },

    //       onError: (error) => {
    //         console.log("Like error", error);
    //       },
    //     }
    //   );
  


    async function handleLike(){
        if (!address) {
            toast.info("You need to sign in first to interact with any post.",{
             position:toast.POSITION.TOP_CENTER
            })
        }
        if(userID==null){
          toast.info("Please Sign Up or Create Your Profile.",{
            position:toast.POSITION.TOP_CENTER
           })
        }
        else{
          const profiles = await lensClient.profile.fetchAll({
            where: {
              ownedBy: [address],
            },
          })

          if(profiles.items.length==0){
            toast.info("Please Sign Up or Create Your Profile.",{
              position:toast.POSITION.TOP_CENTER
             })
          }
          else{
            setUserID(profiles?.items[0].id);
            
            const { id:authID, text } = await lensClient.authentication.generateChallenge({
              signedBy:address,
              for: userID, // e.g "0x01"
            });
            const signature = await signer.signMessage(text); // text returned from authentication.generateChallenge
            await lensClient.authentication.authenticate({ id:authID, signature:signature});
            await lensClient.publication.reactions.add({
              for: id[0].toString(),
              reaction: PublicationReactionType.Upvote,
            });
          }
          }}

    
    return(
      <div className = "intBtn"> 
        <button onClick={()=>{handleLike()}}> <i className="fa-sharp fa-regular fa-heart"></i> </button>
      </div>
    );
}